import debounce from 'lodash/debounce';
import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { searchJob } from 'store/Jobs/actions';
import {
  Wrapper, Input, Button, SearchIcon
} from './styled';

const Search = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(searchJob(''));
  }, [dispatch]);

  const onChangeDebounce = debounce((value) => {
    dispatch(searchJob(value));
  }, 300);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onChangeCallBack = useCallback((value) => onChangeDebounce(value), []);

  const onChange = (e) => {
    onChangeCallBack(e.target.value);
  };

  return (
    <Wrapper>
      <Input placeholder="Search" onChange={ onChange } />
      <Button>
        <SearchIcon />
      </Button>
    </Wrapper>
  );
};
export default Search;
